import styled from 'styled-components';

export default styled.div`
  display: flex;
  padding: 10px;
  padding-top: 0;
`;
